import { useQuery, useQueryClient, UseQueryOptions } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import { TApiProjectSection, TApiTaskDetails } from "../../api-client/types"

interface Props {
  projectId?: string
  taskId?: string
  options?: UseQueryOptions<any,any,Result>
}

interface Result {
  task: TApiTaskDetails
}
export function useGetTaskQuery(props: Props) {
  const {
    projectId,
    taskId,
    options
  } = props

  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  const defaultEnabled = projectId && taskId

  const getTaskQuery = useQuery<{}, {}, Result>(
    ["project-task", projectId, taskId],
    async () => {
      const response = await apiClient.getTask(projectId, taskId)

      if (!response.ok) {
        throw response.errors
      }

      return { 
        task: response.task
      }
    },
    {
      ...options,
      enabled: options?.enabled !== undefined ? !!options?.enabled : !!defaultEnabled,
      onSuccess: (data) => {
        if (options?.onSuccess) {
          options.onSuccess(data)
        }

        // Update task data in all project sections cache
        const projectSectionsQueries = queryClient.getQueriesData(["project-sections"])
        
        projectSectionsQueries.forEach(([_key, sectionsData]) => {
          if (!sectionsData) return

          const updatedSections = sectionsData.projectSections.map((section: TApiProjectSection) => {
            return {
              ...section,
              tasks: {
                ...section.tasks,
                tasks: section.tasks.tasks.map((task) => {
                  if (task.id === taskId) {
                    return {
                      ...data.task,
                      project: task.project // Preserve project data
                    }
                  }
                  return task
                })
              }
            }
          })

          queryClient.setQueryData(_key, {
            projectSections: updatedSections
          })
        })
      }
    }
  )

  return { 
    getTaskQuery,
  }
}